<template>
  <div
    class="tm-detail-overlay"
    :style="dragStyle"
    @pointermove="ziehenBewegen"
    @pointerup="ziehenEnde"
    @pointercancel="ziehenEnde"
  >
    <div class="tm-sheet-griff" @pointerdown="ziehenStart">
      <div class="tm-sheet-griff-inner"></div>
      <button type="button" class="tm-sheet-griff__schliessen" aria-label="Schließen" @pointerdown.stop @click="$emit('close')">✕</button>
    </div>

    <div class="tm-detail-overlay__kopf">
      <span v-if="detail.tab === 'tabelle'" class="tm-kopf-liga">
        <img v-if="detail.match.ligaLogo" :src="detail.match.ligaLogo" class="tm-kopf-liga__logo" alt="" />
        <span class="tm-kopf-liga__texte">
          <span class="tm-kopf-liga__label">Tabelle</span>
          <span class="tm-kopf-liga__name">{{ detail.match.liga }}</span>
        </span>
      </span>
      <span v-else class="tm-detail-overlay__titel">{{ zeigeKopf ? ueberschrift : tabLabel(detail.tab) }}</span>
      <div class="tm-detail-overlay__teilen-gruppe">
        <a href="https://t.me/ike_teammatch" target="_blank" rel="noopener" class="tm-kopf-btn" aria-label="Zum Telegram-Kanal">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
          </svg>
        </a>

        <a v-if="teilenUrl" :href="teilenUrl" target="_blank" rel="noopener" class="tm-kopf-btn" aria-label="Seite im Browser öffnen">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
          </svg>
        </a>

        <button type="button" class="tm-kopf-btn" aria-label="Teilen" @click="teilen">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="tm-detail-overlay__inhalt">
      <div v-if="istStandaloneStory" class="tm-vorschau" v-scroll-melden>
        <BetmanStoryBody :story="detail.story" :zeige-titel="false" />
      </div>

      <template v-else>
        <div v-if="ladeDetails && ['aufstellung', 'events', 'wechsel', 'statistik'].includes(detail.tab)" class="tm-state">
          <span class="tm-state__spinner"></span> Lade Details...
        </div>

        <div v-else-if="detailFehler && ['aufstellung', 'events', 'wechsel', 'statistik'].includes(detail.tab)" class="tm-state tm-state--error">
          {{ detailFehler }}
        </div>

        <div v-else-if="detail.tab === 'vorschau'" class="tm-vorschau" v-scroll-melden>
          <BetmanStoryBody
            v-if="detail.match.storyDatenPreview"
            :story="detail.match.storyDatenPreview"
            :zeige-titel="false"
            :heimtore="detail.match.heimtore"
            :austore="detail.match.austore"
            :heim-logo="detail.match.heimLogo"
            :auswaerts-logo="detail.match.auswaertsLogo"
            :zeige-schnell-links="true"
          />
          <div v-else class="tm-state">Noch keine Vorschau für dieses Spiel verfügbar.</div>
        </div>

        <div v-else-if="detail.tab === 'spielbericht'" class="tm-vorschau" v-scroll-melden>
          <BetmanStoryBody
            v-if="detail.match.storyDatenReport"
            :story="detail.match.storyDatenReport"
            :zeige-titel="false"
            :heimtore="detail.match.heimtore"
            :austore="detail.match.austore"
            :heim-logo="detail.match.heimLogo"
            :auswaerts-logo="detail.match.auswaertsLogo"
            :zeige-schnell-links="true"
          />
          <div v-else class="tm-state">Noch kein Spielbericht für dieses Spiel verfügbar.</div>
        </div>

        <div v-else-if="detail.tab === 'spiele'" class="tm-spiele-tab">
          <MatchKopfSwitch :match="detail.match" v-model="angezeigtesTeam" :kompakt="kopfKompakt" 
            :form-heim="formHeim" 
            :form-auswaerts="formAuswaerts"
            :platz-heim="platzHeim"
            :platz-auswaerts="platzAuswaerts"
            />
          <div class="tm-scroll-bereich" ref="spieleListeRef" v-scroll-melden 
            @scroll.passive="onKopfScroll"
            @wheel.passive="nutzerScrollt = true"
            @touchmove.passive="nutzerScrollt = true"
            @pointerdown="nutzerScrollt = true">
            <ul v-if="spieleAnzeige.length" class="tm-spiele-liste">
              <li v-for="s in spieleAnzeige" :key="s.id" :data-spiel-id="s.id" :class="{ 'tm-spiele-eintrag--beendet': s.status === 'beendet' }">
                <button type="button"
                  :class="['tm-sp-zeile', { 'tm-sp-zeile--aktuell': s.id === detail.match.id }]"
                  @click="oeffneSpiel(s)">

                  <span class="tm-sp-zeit">
                    <template v-if="s.status === 'live'">
                      <span class="tm-spiele-live-punkt" aria-hidden="true"></span>{{ liveText(s) }}
                    </template>
                    <template v-else>
                      <span class="tm-sp-datum">{{ datumKurz(s.zeit) }}</span>
                      <span class="tm-sp-uhr">{{ uhrzeit(s.zeit) }}</span>
                    </template>
                  </span>

                  <span class="tm-sp-teams">
                    <span :class="['tm-sp-team', s.heim === fokusTeamName ? 'tm-sp-team--fokus' : 'tm-sp-team--gegner']">
                      <img v-if="s.heimLogo" :src="s.heimLogo" class="tm-sp-logo" alt="" />
                      <span class="tm-sp-name">{{ s.heim }}</span>
                      <span v-if="s.status !== 'geplant' && s.heimtore != null" class="tm-sp-tore">{{ s.heimtore }}</span>
                    </span>
                    <span :class="['tm-sp-team', s.auswaerts === fokusTeamName ? 'tm-sp-team--fokus' : 'tm-sp-team--gegner']">
                      <img v-if="s.auswaertsLogo" :src="s.auswaertsLogo" class="tm-sp-logo" alt="" />
                      <span class="tm-sp-name">{{ s.auswaerts }}</span>
                      <span v-if="s.status !== 'geplant' && s.austore != null" class="tm-sp-tore">{{ s.austore }}</span>
                    </span>
                  </span>

                  <span class="tm-sp-rechts">
                    <span class="tm-sp-ha">{{ s.heim === fokusTeamName ? 'H' : 'A' }}</span>
                    <img v-if="s.ligaFlaggeBild" :src="s.ligaFlaggeBild" class="tm-sp-flagge" :alt="s.liga" :title="s.liga" />
                    <img v-else-if="s.ligaLogo" :src="s.ligaLogo" class="tm-sp-liga" :alt="s.liga" :title="s.liga" />                  </span>
                </button>
              </li>
            </ul>
            <div v-else class="tm-h2h-leer">Keine Spiele vorhanden.</div>
          </div>
        </div>

        <div v-else-if="detail.tab === 'aufstellung'" class="tm-aufstellung-tab">
          <MatchKopfSwitch :match="detail.match" v-model="angezeigtesTeam" :kompakt="kopfKompakt" 
            :form-heim="formHeim" 
            :form-auswaerts="formAuswaerts"
            :platz-heim="platzHeim"
            :platz-auswaerts="platzAuswaerts"
          />
          <div class="tm-scroll-bereich" v-scroll-melden
              @scroll.passive="onKopfScroll"
              @wheel.passive="nutzerScrollt = true"
              @touchmove.passive="nutzerScrollt = true"
              @pointerdown="nutzerScrollt = true">
            <div class="tm-pitch tm-pitch--einzeln">
              <div class="tm-pitch-team-label tm-pitch-team-label--zentriert">
                {{ lineupAnzeige?.formation ?? '?' }}
              </div>
              <div class="tm-pitch-team">
                <div v-for="(zeile, i) in zeilenAnzeige" :key="i" class="tm-pitch-zeile">
                  <div v-for="eintrag in zeile" :key="eintrag.player?.id" class="tm-pitch-spieler">
                    <div class="tm-pitch-kreis-wrapper">
                      <div class="tm-pitch-kreis" :style="kreisStyle(eintrag, lineupAnzeige?.team?.colors)">
                        {{ eintrag.player?.number }}
                      </div>
                      <span
                        v-if="karten.get(eintrag.player?.id)"
                        :class="['tm-pitch-karte', `tm-pitch-karte--${karten.get(eintrag.player?.id)}`]"
                      ></span>
                      <span v-if="tore.get(eintrag.player?.id)" class="tm-pitch-tor">
                        ⚽<template v-if="tore.get(eintrag.player?.id) > 1">×{{ tore.get(eintrag.player?.id) }}</template>
                      </span>
                    </div>
                    <div class="tm-pitch-name">
                      {{ eintrag.player?.name ?? '–' }}
                      <span v-if="auswechslungen.get(eintrag.player?.id) != null" class="tm-pitch-aus">
                        {{ ' ↓' + auswechslungen.get(eintrag.player?.id) + "'" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="lineupAnzeige?.coach?.name" class="tm-pitch-trainer tm-pitch-trainer--zentriert">
                <div class="tm-trainer-eintrag">
                  <img v-if="lineupAnzeige.coach.photo" :src="lineupAnzeige.coach.photo" class="tm-trainer-foto" alt="" />
                  <div>
                    <div class="tm-trainer-label">Trainer</div>
                    <div class="tm-trainer-name">{{ lineupAnzeige.coach.name }}</div>
                  </div>
                </div>
              </div>
            </div>          
            <div v-if="baenke.length" class="tm-ersatz">
              <div class="tm-ersatz__titel">Ersatzbank</div>
              <div class="tm-ersatz__spalten">
                <ul v-for="seite in baenke" :key="seite.lineup.team?.id"
                    :class="['tm-ersatz__liste', { 'tm-ersatz__liste--rechts': seite.rechts }]">
                  <li v-for="eintrag in seite.spieler" :key="eintrag.player?.id"
                      :class="['tm-ersatz__zeile', { 'tm-ersatz__zeile--ein': einwechslungen.get(eintrag.player?.id) != null }]">
                    <span class="tm-ersatz__nr">{{ eintrag.player?.number }}</span>
                    <span class="tm-ersatz__text">
                      <span class="tm-ersatz__name">{{ eintrag.player?.name ?? '–' }}</span>
                      <span v-if="einwechslungen.get(eintrag.player?.id) != null || karten.get(eintrag.player?.id) || tore.get(eintrag.player?.id)"
                            class="tm-ersatz__infos">
                        <span v-if="einwechslungen.get(eintrag.player?.id) != null" class="tm-ersatz__ein">↑ {{ einwechslungen.get(eintrag.player?.id) }}'</span>
                        <span v-if="karten.get(eintrag.player?.id)" :class="['tm-bank-spieler__karte', `tm-bank-spieler__karte--${karten.get(eintrag.player?.id)}`]"></span>
                        <span v-if="tore.get(eintrag.player?.id)">⚽<template v-if="tore.get(eintrag.player?.id) > 1">×{{ tore.get(eintrag.player?.id) }}</template></span>
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="detail.tab === 'events'" class="tm-events">
          <MatchKopfSwitch
              :match="detail.match"
              :zeige-switch="false"
              :kompakt="kopfKompakt"
              :form-heim="formHeim"
              :form-auswaerts="formAuswaerts"
              :platz-heim="platzHeim"
              :platz-auswaerts="platzAuswaerts"
            />
          <div class="tm-scroll-bereich" v-scroll-melden
              @scroll.passive="onKopfScroll"
              @wheel.passive="nutzerScrollt = true"
              @touchmove.passive="nutzerScrollt = true"
              @pointerdown="nutzerScrollt = true">
            <div v-if="eventsSortiert.length === 0" class="tm-tl-title-empty">Noch keine Ereignisse für dieses Match</div>
            <div v-for="(ev, i) in eventsSortiert" :key="i" :class="['tm-event-zeile', ev.type === 'Goal' ? 'tm-event-zeile--tor' : '']">
              <template v-if="istHeimEvent(ev)">
                <div class="tm-event-seite tm-event-seite--heim">
                  <span class="tm-event-icon">{{ eventIcon(ev) }}</span> {{ ev.time?.elapsed }}' {{ eventText(ev) }}
                </div>
              </template>
              <template v-if="!istHeimEvent(ev)">
                <div class="tm-event-seite tm-event-seite--auswaerts">            
                  <span class="tm-event-icon"></span> {{ ev.time?.elapsed }}' {{ eventText(ev) }} {{ eventIcon(ev) }} 
                </div>
              </template>
            </div>
          </div>
        </div>

        <div v-else-if="detail.tab === 'wechsel'" class="tm-events">
          <MatchKopfSwitch
              :match="detail.match"
              :zeige-switch="false"
              :kompakt="kopfKompakt"
              :form-heim="formHeim"
              :form-auswaerts="formAuswaerts"
              :platz-heim="platzHeim"
              :platz-auswaerts="platzAuswaerts"
            />
          <div class="tm-scroll-bereich" v-scroll-melden
              @scroll.passive="onKopfScroll"
              @wheel.passive="nutzerScrollt = true"
              @touchmove.passive="nutzerScrollt = true"
              @pointerdown="nutzerScrollt = true">
            <div v-if="wechselEreignisse.length === 0" class="tm-tl-title-empty">Noch keine Wechsel in diesem Match</div>

            <div v-for="(ev, i) in wechselEreignisse" :key="i" class="tm-event-zeile">
              <div class="tm-event-seite tm-event-seite--heim tm-wechsel-seite">
                <div v-if="istHeimEvent(ev)" class="tm-wechsel-paar">
                  <span class="tm-wechsel-minute">{{ ev.time?.elapsed }}'</span>
                  <span class="tm-wechsel-rein">↑ {{ ev.assist?.name ?? '?' }}</span>
                  <span class="tm-wechsel-raus">↓ {{ ev.player?.name ?? '?' }}</span>
                </div>
              </div>
              <div class="tm-event-seite tm-event-seite--auswaerts tm-wechsel-seite">
                <div v-if="!istHeimEvent(ev)" class="tm-wechsel-paar">
                  <span class="tm-wechsel-minute">{{ ev.time?.elapsed }}'</span>
                  <span class="tm-wechsel-rein">↑ {{ ev.assist?.name ?? '?' }}</span>
                  <span class="tm-wechsel-raus">↓ {{ ev.player?.name ?? '?' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="detail.tab === 'statistik'" class="tm-statistik" :style="statistikFarben">
          <MatchKopfSwitch
              :match="detail.match"
              :zeige-switch="false"
              :kompakt="kopfKompakt"
              :form-heim="formHeim"
              :form-auswaerts="formAuswaerts"
              :platz-heim="platzHeim"
              :platz-auswaerts="platzAuswaerts"
            />
          <div class="tm-scroll-bereich" v-scroll-melden
              @scroll.passive="onKopfScroll"
              @wheel.passive="nutzerScrollt = true"
              @touchmove.passive="nutzerScrollt = true"
              @pointerdown="nutzerScrollt = true">
            <div v-if="statistikZeilen.length === 0" class="tm-state">Statistik-Daten für dieses Spiel noch nicht verfügbar.</div>

            <template v-else>
              <div v-if="besitzZeile || xgZeile" class="tm-stat-kopfblock">
                <div v-if="besitzZeile" class="tm-stat-besitz">
                  <div class="tm-stat-label2">Ballbesitz</div>
                  <div class="tm-stat-bar">
                    <span :class="['tm-stat-seg','tm-stat-seg--h', fuehrt(besitzZeile,'heim') ? 'is-lead' : 'is-lag']" :style="{ flex: segFlex(besitzZeile.heim) }">{{ besitzZeile.heim ?? '–' }}</span>
                    <span :class="['tm-stat-seg','tm-stat-seg--a', fuehrt(besitzZeile,'auswaerts') ? 'is-lead' : 'is-lag']" :style="{ flex: segFlex(besitzZeile.auswaerts) }">{{ besitzZeile.auswaerts ?? '–' }}</span>
                  </div>
                </div>

                <div v-if="xgZeile" class="tm-stat-xg">
                  <div class="tm-stat-label2">Erwartete Tore (xG)</div>
                  <div class="tm-stat-xg__zahlen">
                    <span :class="['tm-stat-xg__z', fuehrt(xgZeile,'heim') ? 'tm-stat-xg__z--h' : 'tm-stat-xg__z--lag']">{{ xgText(xgZeile.heim) }}</span>
                    <span class="tm-stat-xg__t">:</span>
                    <span :class="['tm-stat-xg__z', fuehrt(xgZeile,'auswaerts') ? 'tm-stat-xg__z--a' : 'tm-stat-xg__z--lag']">{{ xgText(xgZeile.auswaerts) }}</span>
                  </div>
                </div>
              </div>

              <div v-for="g in statistikGruppen" :key="g.titel" class="tm-stat-gruppe">
                <div class="tm-stat-gruppe__titel">{{ g.titel }}</div>
                <div v-for="z in g.zeilen" :key="z.typ" class="tm-stat-item">
                  <div class="tm-stat-label2">{{ statistikLabel(z.typ) }}</div>
                  <div class="tm-stat-bar">
                    <span :class="['tm-stat-seg','tm-stat-seg--h', fuehrt(z,'heim') ? 'is-lead' : 'is-lag']" :style="{ flex: segFlex(z.heim) }">{{ z.heim ?? '–' }}</span>
                    <span :class="['tm-stat-seg','tm-stat-seg--a', fuehrt(z,'auswaerts') ? 'is-lead' : 'is-lag']" :style="{ flex: segFlex(z.auswaerts) }">{{ z.auswaerts ?? '–' }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div v-else-if="detail.tab === 'ausfaelle'" class="tm-ausfaelle-tab">
          <MatchKopfSwitch
              :match="detail.match"
              :zeige-switch="false"
              :kompakt="kopfKompakt"
              :form-heim="formHeim"
              :form-auswaerts="formAuswaerts"
              :platz-heim="platzHeim"
              :platz-auswaerts="platzAuswaerts"
            />
          <div class="tm-scroll-bereich" v-scroll-melden              
              @scroll.passive="onKopfScroll"
              @wheel.passive="nutzerScrollt = true"
              @touchmove.passive="nutzerScrollt = true"
              @pointerdown="nutzerScrollt = true">
            <div class="tm-events">
              <div v-for="(r, i) in ausfaelleReihen" :key="i" class="tm-event-zeile">
                <div class="tm-event-seite tm-event-seite--heim">
                  <template v-if="r.heim">
                    <span class="tm-event-icon">{{ ausfallIcon(r.heim.grund) }}</span>
                    <div class="tm-ausfall-info">
                      <div class="tm-ausfall-name">{{ r.heim.name }} <span class="tm-ausfall-grund">({{ r.heim.grund }})</span></div>
                      <div v-if="r.heim.detail" class="tm-ausfall-detail">{{ r.heim.detail }}</div>
                    </div>
                  </template>
                </div>
                <div class="tm-event-seite tm-event-seite--auswaerts">
                  <template v-if="r.auswaerts">
                    <span class="tm-event-icon">{{ ausfallIcon(r.auswaerts.grund) }}</span>
                    <div class="tm-ausfall-info">
                      <div class="tm-ausfall-name">{{ r.auswaerts.name }} <span class="tm-ausfall-grund">({{ r.auswaerts.grund }})</span></div>
                      <div v-if="r.auswaerts.detail" class="tm-ausfall-detail">{{ r.auswaerts.detail }}</div>
                    </div>
                  </template>
                </div>
              </div>

              <div v-if="!ausfaelleReihen.length" class="tm-h2h-leer">
                {{ hatRecherche ? 'Keine Ausfälle gemeldet.' : 'Zu diesem Spiel liegen noch keine Angaben vor.' }}
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="detail.tab === 'fakten'" class="tm-fakten-tab">
          <MatchKopfSwitch
              :match="detail.match"
              :zeige-switch="false"
              :kompakt="kopfKompakt"
              :form-heim="formHeim"
              :form-auswaerts="formAuswaerts"
              :platz-heim="platzHeim"
              :platz-auswaerts="platzAuswaerts"
            />
          <div class="tm-scroll-bereich" v-scroll-melden
              @scroll.passive="onKopfScroll"
              @wheel.passive="nutzerScrollt = true"
              @touchmove.passive="nutzerScrollt = true"
              @pointerdown="nutzerScrollt = true">
            <template v-if="faktenReport.length || faktenListe.length">
              <section v-if="faktenReport.length" class="tm-fakten-block">
                <h4 class="tm-fakten-titel">Nach dem Spiel</h4>
                <ul class="tm-fakten-liste">
                  <li v-for="(f, i) in faktenReport" :key="'r' + i">{{ f }}</li>
                </ul>
                <p v-if="faktenStandReport" class="tm-fakten-stand">Stand: {{ faktenStandReport }}</p>
              </section>

              <section v-if="faktenListe.length" class="tm-fakten-block">
                <h4 class="tm-fakten-titel">Vor dem Spiel</h4>
                <ul class="tm-fakten-liste">
                  <li v-for="(f, i) in faktenListe" :key="'v' + i">{{ f }}</li>
                </ul>
                <p v-if="faktenStand" class="tm-fakten-stand">Stand: {{ faktenStand }}</p>
              </section>
            </template>

            <div v-else class="tm-h2h-leer">
              {{ hatRecherche ? 'Keine weiteren Fakten verfügbar.' : 'Zu diesem Spiel liegen noch keine Angaben vor.' }}
            </div>
          </div>
        </div>

          <div v-else-if="detail.tab === 'h2h'" class="tm-h2h-tab">
            <MatchKopfSwitch
                :match="detail.match"
                :zeige-switch="false"
                :kompakt="kopfKompakt"
                :form-heim="formHeim"
                :form-auswaerts="formAuswaerts"
                :platz-heim="platzHeim"
                :platz-auswaerts="platzAuswaerts"
              />
            <div class="tm-scroll-bereich" v-scroll-melden
              @scroll.passive="onKopfScroll"
              @wheel.passive="nutzerScrollt = true"
              @touchmove.passive="nutzerScrollt = true"
              @pointerdown="nutzerScrollt = true">
              <div class="tm-h2h-liste">
                <div
                  v-for="spiel in h2hSpiele"
                  :key="spiel.datumRoh"
                  class="tm-h2h-zeile"
                >
                  <div class="tm-h2h-links">
                    <div v-if="spiel.liga" class="tm-h2h-liga">{{ spiel.liga }}</div>
                    <div class="tm-h2h-datum">{{ spiel.datum }}</div>
                    <div class="tm-h2h-ort">
                      {{ spiel.stadt }}<span v-if="spiel.stadion">, {{ spiel.stadion }}</span>
                    </div>
                  </div>

                  <div class="tm-h2h-rechts">
                    <div
                      class="tm-h2h-team-zeile"
                      :class="{ 'tm-h2h-team-zeile--sieger': spiel.toreHeim > spiel.toreAuswaerts }"
                    >
                      <span class="tm-h2h-team-name">{{ spiel.heim }}</span>
                      <span class="tm-h2h-team-tore">{{ spiel.toreHeim }}</span>
                    </div>
                    <div
                      class="tm-h2h-team-zeile"
                      :class="{ 'tm-h2h-team-zeile--sieger': spiel.toreAuswaerts > spiel.toreHeim }"
                    >
                      <span class="tm-h2h-team-name">{{ spiel.auswaerts }}</span>
                      <span class="tm-h2h-team-tore">{{ spiel.toreAuswaerts }}</span>
                    </div>
                  </div>
                </div>

                <div v-if="!h2hSpiele.length" class="tm-h2h-leer">
                  Keine bisherigen Begegnungen gefunden.
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="detail.tab === 'tabelle'" class="tm-tabelle-tab">
            <div class="tm-scroll-bereich" v-scroll-melden>
              <div v-if="tabelleLaedt" class="tm-state">
                <span class="tm-state__spinner"></span> Lade Tabelle...
              </div>
              <div v-else-if="tabelleFehler" class="tm-state tm-state--error">{{ tabelleFehler }}</div>
              <TabelleContent v-else :tabellen="effektiveTabellen" :match="detail.match" />
            </div>
          </div>

        </template>
      </div>

      <div v-if="!istStandaloneStory" ref="tabsRef" class="tm-detail-overlay__tabs tm-detail-overlay__tabs--unten" @wheel.prevent="tabsRad">
        <button
          v-for="t in verfuegbareTabs"
          :key="t"
          type="button"
          :class="['tm-tabbar__btn', { 'tm-tabbar__btn--aktiv': detail.tab === t }]"
          :aria-label="tabLabel(t)"
          @click="$emit('change-tab', t)"
        >
          <span class="tm-tabbar__icon"><TabIcon :name="t" /></span>
          <span class="tm-tabbar__label">{{ tabLabel(t) }}</span>
        </button>
      </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { useSheetDrag } from '../composables/useSheetDrag.js'
import BetmanStoryBody from './BetmanStoryBody.vue'
import MatchKopfSwitch from './MatchKopfSwitch.vue'
import TabelleContent from './TabelleContent.vue'
import TabIcon from './TabIcon.vue'
import { ladeMatchDetails, invalidiereMatchDetails } from '../lib/matchDetails.js'
import { ladeTabelleFuerLiga } from '../lib/matchLookup.js'
import { tabelleFuerLiga } from '../lib/standings.js'
import { vScrollMelden } from '../lib/scrollLock.js'
import { mapH2H, parseJsonFeld, mapTeamSpiel } from '../lib/mapping.js' // Pfad anpassen
import { formatDatumKurz as datumKurz, formatUhrzeitKurz as uhrzeit } from '../lib/format.js'

const props = defineProps({
  detail: { type: Object, required: true },
  // Für den Lazy-Load der Detail-Daten (Aufstellung/Events/Statistik) - dieselbe apiBase, die
  // auch für den Spielplan-Fetch genutzt wird.
  apiBase: { type: String, required: true },
  // Für den "tabelle"-Tab (siehe TabelleContent.vue) - dieselben tabellen, die auch
  // StandingsOverlay bekommt (aus useSpielplanData: raw.groups)
  tabellen: { type: Array, default: () => [] }
})
const emit = defineEmits(['close', 'change-tab'])

const { ziehenStart, ziehenBewegen, ziehenEnde, dragStyle } = useSheetDrag(() => emit('close'))

// NEU: detail kann jetzt zwei Formen haben - { match, tab } (match-gebundene Anzeige) ODER
// { story } (eigenständige, matchlose Story - Transfer/Verletzung/Gerücht/etc., kein Match,
// keine Tabs). istStandaloneStory steuert die Verzweigung im Template UND schützt die beiden
// watch()-Aufrufe unten (die sonst bei fehlendem match sofort crashen würden, siehe dort).
const istStandaloneStory = computed(() => !!props.detail.story)

const m = computed(() => props.detail.match)
//console.log('story', props.detail.match?.storyPreview, props.detail.match?.storyReport)
const heim = computed(() => m.value.lineups[0])
const auswaerts = computed(() => m.value.lineups[1])
const ausfaelleHeim = computed(() => m.value.ausfaelle?.heim ?? [])
const ausfaelleAuswaerts = computed(() => m.value.ausfaelle?.auswaerts ?? [])
const ausfaelleZeilen = computed(() => [
  ...ausfaelleHeim.value.map(a => ({ ...a, seite: 'heim' })),
  ...ausfaelleAuswaerts.value.map(a => ({ ...a, seite: 'auswaerts' }))
])
const ausfaelleReihen = computed(() => {
  const n = Math.max(ausfaelleHeim.value.length, ausfaelleAuswaerts.value.length)
  return Array.from({ length: n }, (_, i) => ({
    heim: ausfaelleHeim.value[i] ?? null,
    auswaerts: ausfaelleAuswaerts.value[i] ?? null,
  }))
})
const h2hSpiele = computed(() => m.value?.h2h ?? [])
const faktenListe = computed(() => (m.value?.weitereFakten ?? []).slice(0, 6))
const hatRecherche = computed(() => !!m.value?.hatRecherche)
const faktenStand = computed(() => {
  const t = m.value?.erstelltAm
  if (!t) return null
  return new Date(t).toLocaleString('de-AT',
    { weekday: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Vienna' })
})
const faktenReport = computed(() => (m.value.weitereFaktenReport ?? []).slice(0, 6))
const angezeigtesTeam = ref('heim')

const kopfKompakt = ref(false)
const nutzerScrollt = ref(false)
function onKopfScroll(e) {
  if (!nutzerScrollt.value) return          // Auto-Scroll zum nächsten Spiel ignorieren
  const y = e.target.scrollTop
  if (!kopfKompakt.value && y > 40) kopfKompakt.value = true
  else if (kopfKompakt.value && y < 8) kopfKompakt.value = false
}
// Tab- oder Teamwechsel: wieder von vorn, Kopf groß
watch([() => props.detail.tab, angezeigtesTeam], () => {
  nutzerScrollt.value = false
  kopfKompakt.value = false
})

function sortiereBank(liste) {
  return [...liste].sort((a, b) => {
    const ea = einwechslungen.value.get(a.player?.id)
    const eb = einwechslungen.value.get(b.player?.id)
    if (ea != null && eb != null) return ea - eb
    if (ea != null) return -1
    if (eb != null) return 1
    return 0
  })
}

// Mausrad scrollt die Tab-Leiste seitlich (Desktop)
function tabsRad(e) {
  e.currentTarget.scrollLeft += e.deltaY || e.deltaX
}

const baenke = computed(() => [
  { lineup: heim.value, rechts: false },
  { lineup: auswaerts.value, rechts: true }
].filter(b => b.lineup?.substitutes?.length)
 .map(b => ({ ...b, spieler: sortiereBank(b.lineup.substitutes) })))

const spieleAnzeige = computed(() => {
  const l = angezeigtesTeam.value === 'heim' ? m.value.spieleHeim : m.value.spieleAuswaerts
  return [...(l ?? [])].sort((a, b) => new Date(a.zeit) - new Date(b.zeit))
})

const liveText = s =>
  s.spielUhrKurz === 'HT' ? 'Live HT' : (s.minute ? `Live ${s.minute}'` : 'Live')

const formatStand = (iso) => iso
  ? new Date(iso).toLocaleString('de-AT', { weekday: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Vienna' })
  : null
const faktenStandReport = computed(() => formatStand(m.value.erstelltAmReport))

// Bei Vorschau/Spielbericht die STORY-eigene Überschrift zeigen (kommt von der Story-Card selbst,
// nicht vom Match) - relevant v.a. für "reine" Betman-Stories, wo heim/auswaerts am Match leer
// oder generisch sein können. Bei allen anderen Tabs (Aufstellung/Events/Statistik) bleibt's bei
// Heim – Auswärts, da's dort ja tatsächlich um das Match geht, nicht um die Story.
// NEU: Kopf (Titel + Teilen-Button) optional ausblenden, je nach Tab - einfach anpassbare
// Liste, ergänzen/entfernen nach Bedarf. Aktuell nur "tabelle" drin (hat vermutlich schon einen
// eigenen Liga-Titel/Kopf in TabelleContent.vue).
const KOPF_AUSGEBLENDET_BEI_TABS = ['tabelle', 'aufstellung', 'events', 'statistik', 'wechsel', 'ausfaelle', 'h2h', 'fakten', 'spiele']
const zeigeKopf = computed(() => !KOPF_AUSGEBLENDET_BEI_TABS.includes(props.detail.tab))

// Bei Vorschau/Spielbericht die STORY-eigene Überschrift zeigen (kommt von der Story-Card selbst,
// nicht vom Match) - relevant v.a. für "reine" Betman-Stories, wo heim/auswaerts am Match leer
// oder generisch sein können. Bei allen anderen Tabs (Aufstellung/Events/Statistik) bleibt's bei
// Heim – Auswärts, da's dort ja tatsächlich um das Match geht, nicht um die Story.
const ueberschrift = computed(() => {
  // NEU: Standalone-Story - eigene Überschrift aus story.titel, oder heim/auswaerts falls
  // vorhanden (z.B. bei einer Story, die zwar keinem Match zugeordnet ist, aber trotzdem zwei
  // Teams nennt), sonst leer.
  if (istStandaloneStory.value) {
    const s = props.detail.story
    if (s?.titel) return s.titel
    if (s?.heim && s?.auswaerts) return `${s.heim} – ${s.auswaerts}`
    return ''
  }
  if (props.detail.tab === 'vorschau' && m.value.storyDatenPreview?.titel) {
    return m.value.storyDatenPreview.titel
  }
  if (props.detail.tab === 'spielbericht' && m.value.storyDatenReport?.titel) {
    return m.value.storyDatenReport.titel
  }
  return `${m.value.heim} – ${m.value.auswaerts}`
})

// NEU: ermittelt die Teilen-URL je nach aktuell angezeigtem Inhalt - Standalone-Story hat ihre
// eigene story.url, Vorschau/Bericht-Tab greifen auf die jeweilige storyDaten*.url zu. Andere
// Tabs (Aufstellung/Events/Statistik/Tabelle) haben keine sinnvolle Teilen-URL, dort bleibt der
// Button ausgeblendet (v-if="teilenUrl" im Template).
const teilenUrl = computed(() => {
  if (istStandaloneStory.value) return props.detail.story?.url ?? null
  const id = m.value?.id
  if (id == null) return null
  const u = new URL(window.location.href)
  u.hash = ''
  u.searchParams.set('tm-match', String(id))
  return u.toString()
})

// NEU: Telegrams eigenes Share-URL-Schema (https://t.me/share/url?url=...&text=...) - öffnet
// Telegrams Teilen-Dialog direkt mit vorausgefüllter URL+Titel, statt über die generische
// Web-Share-API zu gehen (die bietet Telegram zwar meist auch als Option an, aber ein direkter
// Telegram-Link ist ein Klick schneller für Nutzer, die eh dort teilen wollen).
// GEÄNDERT: fester Channel-Link statt dynamischem Telegram-Share-Schema - Button führt jetzt
// direkt zum Kanal, nicht zu einem vorausgefüllten Teilen-Dialog für die einzelne Story.
const telegramShareUrl = computed(() => {
  return "https://t.me/ike_teammatch" //`https://t.me/share/url?${params}`
})

// Gleiche Logik wie in BetmanStoryCardErweitert.vue - Web-Share-API bevorzugt, Zwischenablage
// als Fallback für Browser ohne Unterstützung.
async function teilen() {
  if (!teilenUrl.value) return
  if (navigator.share) {
    try {
      await navigator.share({ url: teilenUrl.value, title: ueberschrift.value })
    } catch {
      // Nutzer hat den Teilen-Dialog abgebrochen - kein Fehler, einfach nichts tun
    }
  } else if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(teilenUrl.value)
    } catch (e) {
      console.warn('Teilen fehlgeschlagen:', e)
    }
  }
}

// ---------- Lazy-Loading der Detail-Daten ----------
// GEÄNDERT (Vereinfachung): Statt zu versuchen, aus den (unzuverlässigen) Server-Flags zu
// RATEN, ob Aufstellung/Events/Statistik existieren, laden wir die echten Daten jetzt IMMER
// sofort beim Öffnen, für JEDES Match (unabhängig von Status/Flags). Solange geladen wird,
// zeigen wir einen Ladezustand statt der Tab-Leiste. Die Tabs selbst richten sich danach NUR
// noch nach den TATSÄCHLICH geladenen Arrays (lineups.length > 0 etc.) - Flags spielen für die
// Sichtbarkeit keine Rolle mehr. Das eliminiert die ganze Flag-Zuverlässigkeits-Problematik,
// statt sie mit immer mehr Sonderfällen (live/beendet/optimistisch/etc.) zu patchen.
const ladeDetails = ref(false)
const detailFehler = ref(null)
const detailsWurdenGeladen = ref(false)

async function ladeFallsNoetig() {
  detailsWurdenGeladen.value = false
  const istLive = m.value.status === 'live'

  const schonGeladen = ((m.value.lineups?.length ?? 0) > 0
    || (m.value.events?.length ?? 0) > 0
    || (m.value.statistiken?.length ?? 0) > 0)
    && m.value.spieleHeim !== undefined

  // Bei laufenden Spielen IMMER frisch nachladen (Cache umgehen) - lineups/events/statistics
  // ändern sich ja laufend. Bei allen anderen (beendet/geplant) reicht der einmal geladene
  // Stand, der bleibt unverändert gültig, kein Grund für einen erneuten Request.
  if (istLive) {
    invalidiereMatchDetails(m.value.id)
  } else if (schonGeladen) {
    detailsWurdenGeladen.value = true
    return
  }

  ladeDetails.value = true
  detailFehler.value = null
  try {
    const daten = await ladeMatchDetails(props.apiBase, m.value.id)
    m.value.lineups = daten.lineups ?? []
    m.value.events = daten.events ?? []
    m.value.statistiken = Array.isArray(daten.statistics) ? daten.statistics : []

    if (daten.head2head) {
      m.value.h2h = mapH2H(parseJsonFeld(daten.head2head, []))
    }

    m.value.spieleHeim = (daten.teamSpieleHeimRoh ?? []).map(mapTeamSpiel)
    m.value.spieleAuswaerts = (daten.teamSpieleAuswaertsRoh ?? []).map(mapTeamSpiel)

  } catch (e) {
    detailFehler.value = 'Details konnten nicht geladen werden.'
    console.warn('ladeMatchDetails fehlgeschlagen:', e)
  } finally {
    ladeDetails.value = false
    detailsWurdenGeladen.value = true
  }
}

// Läuft bei jedem Öffnen oder Match-Wechsel - nur noch von der Match-ID abhängig (nicht mehr
// vom Tab), da wir jetzt ALLE Details sofort beim Öffnen laden, statt pro angeklicktem Tab
// nachzuladen. Bei Live-Spielen läuft das trotzdem regelmäßig neu, siehe Cache-Umgehung oben.
watch(() => props.detail.match ? props.detail.match.id : null, (wert) => {
  if (!wert) return
  ladeFallsNoetig()
}, { immediate: true })

function tabLabel(t) {
  return { vorschau: 'Vorschau', spielbericht: 'Spielbericht', aufstellung: 'Aufstellung', events: 'Events', wechsel: 'Wechsel', statistik: 'Statistik', ausfaelle: 'Ausfälle', fakten: 'Fakten', h2h: 'Direkter Vergleich', tabelle: 'Tabelle', spiele: 'Spiele' }[t]
}

/*
function tabIcon(t) {
  return { vorschau: '📰', spielbericht: '📝', aufstellung: '👕', events: '⚽', wechsel: '🔄', statistik: '📈', ausfaelle: '🚑', fakten: '💡', h2h: '🆚', tabelle: '📊', spiele: '📅' }[t]
}*/

// GEÄNDERT (Vereinfachung): Aufstellung/Events/Statistik richten sich jetzt NUR noch nach den
// tatsächlich geladenen Arrays, nicht mehr nach Flags oder Status-Sonderfällen. Solange noch
// nicht geladen wurde (detailsWurdenGeladen=false), werden diese drei Tabs einfach NICHT
// gezeigt - kein Rätselraten, kein Aufblitzen, keine dauerhaft leeren Tabs. Sobald geladen,
// zeigen sie sich genau dann, wenn tatsächlich Inhalt da ist.
const verfuegbareTabs = computed(() => {
  const tabs = []
  if (m.value.storyPreview) tabs.push('vorschau')
  if (m.value.storyReport) tabs.push('spielbericht')
  if (detailsWurdenGeladen.value) {
    if (m.value.lineups?.length > 0) tabs.push('aufstellung')
    if (m.value.events?.length > 0) tabs.push('events')
    if (m.value.events?.length > 0) tabs.push('wechsel')
    if (m.value.statistiken?.length > 0) tabs.push('statistik')
  }
  if (ausfaelleHeim.value.length > 0 || ausfaelleAuswaerts.value.length > 0) tabs.push('ausfaelle')
  if (faktenListe.value.length > 0 || faktenReport.value.length > 0) tabs.push('fakten')
  if (h2hSpiele.value.length > 0) tabs.push('h2h')
  if (m.value.ligaId != null) tabs.push('tabelle')
  if ((m.value.spieleHeim?.length ?? 0) + (m.value.spieleAuswaerts?.length ?? 0) > 0) tabs.push('spiele')
  return tabs
})

// ---------- Tabelle lazy nachladen (falls nicht schon über die tabellen-Prop vorhanden) ----------
// SpielplanWidget/StartseiteWidget laden Tabellen weiterhin vorab mit (raw.groups aus dem großen
// Spielplan-Request) - dort greift einfach die tabellen-Prop direkt, kein Nachladen nötig.
// BetmanStoryWidget lädt Tabellen NICHT vorab (würde den kompletten Spielplan brauchen) -
// deshalb hier ein Fallback: fehlt für diese Liga was in der Prop, lazy nach ligaId nachladen,
// gecacht (siehe lib/matchLookup.js: zwei Matches derselben Liga teilen sich den Request).
const tabelleLazyGeladen = ref([])
const tabelleLaedt = ref(false)
const tabelleFehler = ref(null)

const effektiveTabellen = computed(() => {
  const ausProp = tabelleFuerLiga(props.tabellen, m.value.ligaId)
  return ausProp.length > 0 ? props.tabellen : tabelleLazyGeladen.value
})

// GEÄNDERT: gleiches Guard-Muster wie beim vorigen watch oben - schützt vor Zugriff auf
// props.detail.match.id bei einer Standalone-Story (kein match vorhanden).
watch(() => props.detail.match ? [props.detail.match.id, props.detail.tab] : null, async (wert) => {
  if (!wert) return
  const [, tab] = wert
  if (tab !== 'tabelle') return
  if (tabelleFuerLiga(props.tabellen, m.value.ligaId).length > 0) return // schon über Prop da
  if (tabelleFuerLiga(tabelleLazyGeladen.value, m.value.ligaId).length > 0) return // schon lazy geladen

  tabelleLaedt.value = true
  tabelleFehler.value = null
  try {
    tabelleLazyGeladen.value = await ladeTabelleFuerLiga(props.apiBase, m.value.ligaId)
  } catch (e) {
    tabelleFehler.value = 'Tabelle konnte nicht geladen werden.'
    console.warn('ladeTabelleFuerLiga fehlgeschlagen:', e)
  } finally {
    tabelleLaedt.value = false
  }
}, { immediate: true })


const lineupAnzeige = computed(() => angezeigtesTeam.value === 'heim' ? heim.value : auswaerts.value)

const fokusTeamName = computed(() =>
  angezeigtesTeam.value === 'heim' ? m.value.heim : m.value.auswaerts
)

const spieleListeRef = ref(null)

const spieleZielId = computed(() => {
  const l = spieleAnzeige.value
  const live = l.find(s => s.status === 'live')
  if (live) return live.id
  const jetzt = Date.now()
  const naechstes = l.find(s => s.status === 'geplant' && new Date(s.zeit).getTime() >= jetzt)
  return (naechstes ?? l[l.length - 1])?.id ?? null
})

function scrolleZumZiel() {
  const box = spieleListeRef.value
   console.log('[spiele-scroll]', { box: !!box, zielId: spieleZielId.value })
  if (!box || spieleZielId.value == null) return
  const zeile = box.querySelector(`[data-spiel-id="${spieleZielId.value}"]`)
  console.log('[spiele-scroll]', {
  box: !!box,
  zielId: spieleZielId.value,
  zeile: !!zeile,
  scrollHeight: box?.scrollHeight,
  clientHeight: box?.clientHeight
})
  if (!zeile) return
  box.scrollTop += zeile.getBoundingClientRect().top - box.getBoundingClientRect().top - 8
}

watch(
  [() => props.detail.tab, angezeigtesTeam, () => spieleAnzeige.value.length],
  () => { if (props.detail.tab === 'spiele') scrolleZumZiel() },
  { flush: 'post' }
)

watch(spieleListeRef, el => { if (el) scrolleZumZiel() })

function zeilenGruppieren(startXI) {
  const zeilen = {}
  for (const eintrag of startXI ?? []) {
    const reihe = Number((eintrag.player?.grid ?? '0:0').split(':')[0])
    if (!zeilen[reihe]) zeilen[reihe] = []
    zeilen[reihe].push(eintrag)
  }
  return Object.keys(zeilen).sort((a, b) => a - b).map(r => zeilen[r])
}

const zeilenAnzeige = computed(() => [...zeilenGruppieren(lineupAnzeige.value?.startXI)].reverse())

const auswechslungen = computed(() => {
  const map = new Map()
  for (const ev of m.value.events ?? []) {
    if (ev.type === 'subst' && ev.player?.id != null) map.set(ev.player.id, ev.time?.elapsed)
  }
  return map
})
const karten = computed(() => {
  const map = new Map()
  for (const ev of m.value.events ?? []) {
    if (ev.type === 'Card' && ev.player?.id != null) {
      map.set(ev.player.id, ev.detail?.toLowerCase().includes('red') ? 'rot' : 'gelb')
    }
  }
  return map
})
// Tore pro Spieler (Anzahl statt nur Ja/Nein, falls jemand mehrfach getroffen hat) - fürs
// Ball-Symbol am Spieler-Kreis in der Aufstellung.
const tore = computed(() => {
  const map = new Map()
  for (const ev of m.value.events ?? []) {
    if (ev.type === 'Goal' && ev.player?.id != null) {
      map.set(ev.player.id, (map.get(ev.player.id) ?? 0) + 1)
    }
  }
  return map
})

function hexFarbe(f) {
  return f ? `#${String(f).replace('#', '')}` : undefined
}

function leuchtdichte(hex) {
  if (!hex) return null
  const h = hex.replace('#', '')
  if (h.length < 6) return null
  const r = parseInt(h.substring(0, 2), 16)
  const g = parseInt(h.substring(2, 4), 16)
  const b = parseInt(h.substring(4, 6), 16)
  if ([r, g, b].some(Number.isNaN)) return null
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255
}

function textFarbeMitKontrast(hintergrundHex, gewuenschteFarbe) {
  const bgLum = leuchtdichte(hintergrundHex)
  const fgLum = leuchtdichte(gewuenschteFarbe)
  if (bgLum == null || fgLum == null) return gewuenschteFarbe
  if (Math.abs(bgLum - fgLum) < 0.4) {
    return bgLum > 0.5 ? '#111111' : '#ffffff'
  }
  return gewuenschteFarbe
}

function kreisStyle(eintrag, farben) {
  const istKeeper = eintrag.player?.pos === 'G'
  const satz = istKeeper ? farben?.goalkeeper : farben?.player

  // Keine Farben von der API: feste Rückfallfarben (Heim grün, Auswärts orange, Torwart grau)
  if (!satz) {
    const bg = istKeeper ? '#4b5563' : (angezeigtesTeam.value === 'heim' ? '#1d9e75' : '#e8833a')
    return { background: bg, color: '#ffffff', borderColor: '#ffffff' }
  }

  const bg = hexFarbe(satz.primary)
  return {
    background: bg,
    color: textFarbeMitKontrast(bg, hexFarbe(satz.number)),
    borderColor: hexFarbe(satz.border)
  }
}

const einwechslungen = computed(() => {
  const map = new Map()
  for (const ev of m.value.events ?? []) {
    if (ev.type === 'subst' && ev.assist?.id != null) map.set(ev.assist.id, ev.time?.elapsed)
  }
  return map
})

const torschuetzen = computed(() => {
  const set = new Set()
  for (const ev of m.value.events ?? []) {
    if (ev.type === 'Goal' && ev.player?.id != null) set.add(ev.player.id)
  }
  return set
})

const wechselEreignisse = computed(() =>
  [...(m.value.events ?? [])]
    .filter(ev => ev.type === 'subst')
    .sort((a, b) => (a.time?.elapsed ?? 0) - (b.time?.elapsed ?? 0))
)

function eventIcon(ev) {
  if (ev.type === 'Goal') return '⚽'
  if (ev.type === 'Card') return ev.detail?.toLowerCase().includes('red') ? '🟥' : '🟨'
  if (ev.type === 'subst') return '🔄'
  return '•'
}
function eventText(ev) {
  if (ev.type === 'subst') return `${ev.player?.name ?? '?'} → ${ev.assist?.name ?? '?'}`
  if (ev.type === 'Goal' && ev.assist?.name) return `${ev.player?.name ?? '–'} (Vorlage: ${ev.assist.name})`
  return ev.player?.name ?? '–'
}
function istHeimEvent(ev) {
  return ev.team?.id === heim.value?.team?.id
}

const eventsSortiert = computed(() =>
  [...(m.value.events ?? [])].sort((a, b) => (a.time?.elapsed ?? 0) - (b.time?.elapsed ?? 0))
)

const STATISTIK_LABELS = {
  'Shots on Goal': 'Schüsse aufs Tor',
  'Shots off Goal': 'Schüsse daneben',
  'Total Shots': 'Schüsse gesamt',
  'Blocked Shots': 'Geblockte Schüsse',
  'Shots insidebox': 'Schüsse im Strafraum',
  'Shots outsidebox': 'Schüsse außerhalb',
  'Fouls': 'Fouls',
  'Corner Kicks': 'Ecken',
  'Offsides': 'Abseits',
  'Ball Possession': 'Ballbesitz',
  'Yellow Cards': 'Gelbe Karten',
  'Red Cards': 'Rote Karten',
  'Goalkeeper Saves': 'Paraden',
  'Total passes': 'Pässe gesamt',
  'Passes accurate': 'Pässe genau',
  'Passes %': 'Passquote',
  'expected_goals': 'Erwartete Tore (xG)',
  'goals_prevented': 'Verhinderte Tore'
}

function statistikLabel(typ) {
  return STATISTIK_LABELS[typ] ?? typ
}

// NEU: Prioritätsliste statt nur Ballbesitz als Einzelfall - alles, was hier drinsteht, kommt
// in GENAU dieser Reihenfolge ganz nach oben. Alles andere (nicht gelistet) folgt danach in der
// ursprünglichen API-Reihenfolge. Schlüsselwörter klein geschrieben, Teilstring-Vergleich -
// unabhängig von genauer API-Schreibweise/Sprache ("Ball Possession", "Total Shots", etc.).
const STATISTIK_PRIORITAET = [
  'possession', // Ballbesitz
  'total shots', // Torschüsse gesamt
  'shots on goal', // Schüsse aufs Tor
  'corner' // Eckbälle
]
 
function ermittlePrioritaet(typ) {
  const typKlein = typ.toLowerCase()
  return STATISTIK_PRIORITAET.findIndex(schluesselwort => typKlein.includes(schluesselwort))
}

const statistikZeilen = computed(() => {
  const roh = m.value.statistiken
  if (!Array.isArray(roh) || roh.length !== 2) return []

  const heimEintrag = roh.find(s => s.team?.id === m.value.heimId) ?? roh[0]
  const auswaertsEintrag = roh.find(s => s.team?.id === m.value.auswaertsId) ?? roh[1]
  const mapHeim = new Map((heimEintrag?.statistics ?? []).map(s => [s.type, s.value]))
  const mapAuswaerts = new Map((auswaertsEintrag?.statistics ?? []).map(s => [s.type, s.value]))

  const typen = [...new Set([...mapHeim.keys(), ...mapAuswaerts.keys()])]
  
  return typen
    .map(typ => ({ typ, heim: mapHeim.get(typ) ?? null, auswaerts: mapAuswaerts.get(typ) ?? null }))
    .filter(z => z.heim != null || z.auswaerts != null)
    .sort((a, b) => {
      const prioA = ermittlePrioritaet(a.typ)
      const prioB = ermittlePrioritaet(b.typ)
      // Nicht gelistete Typen (-1) ans Ende, sonst aufsteigend nach Position in der Liste.
      // Stabiler Sort: nicht gelistete Typen behalten untereinander ihre ursprüngliche
      // Reihenfolge (alle bekommen denselben Infinity-Wert, .sort() rührt Gleichstände nicht an).
      const wertA = prioA === -1 ? Infinity : prioA
      const wertB = prioB === -1 ? Infinity : prioB
      return wertA - wertB
    })
})

function zuZahl(wert) {
  if (typeof wert === 'number') return wert
  if (typeof wert === 'string') {
    const n = parseFloat(wert)
    return Number.isNaN(n) ? 0 : n
  }
  return 0
}

function ausfallIcon(grund) {
  if (grund === 'gesperrt') return '🟥'
  if (grund === 'fraglich') return '❓'
  return '🚑' // verletzt (Standard/Fallback)
}

function balkenAnteile(heim, auswaerts) {
  const h = zuZahl(heim)
  const a = zuZahl(auswaerts)
  const summe = h + a
  if (summe === 0) return { heim: 50, auswaerts: 50 }
  return { heim: (h / summe) * 100, auswaerts: (a / summe) * 100 }
}

const GRUPPEN = [
  { titel: 'Angriff', typen: ['Total Shots', 'Shots on Goal', 'Shots insidebox', 'Shots outsidebox', 'Shots off Goal', 'Blocked Shots', 'Goalkeeper Saves'] },
  { titel: 'Kontrolle', typen: ['Corner Kicks', 'Total passes', 'Passes accurate', 'Passes %', 'Offsides'] },
  { titel: 'Disziplin', typen: ['Fouls', 'Free Kicks', 'Yellow Cards', 'Red Cards'] }
]

const besitzZeile = computed(() => statistikZeilen.value.find(z => z.typ === 'Ball Possession'))
const xgZeile = computed(() => statistikZeilen.value.find(z => z.typ === 'expected_goals'))

const statistikGruppen = computed(() => {
  const rest = statistikZeilen.value.filter(z => z.typ !== 'Ball Possession' && z.typ !== 'expected_goals')
  const belegt = new Set()
  const gruppen = GRUPPEN.map(g => {
    const zeilen = g.typen.map(t => rest.find(z => z.typ === t)).filter(Boolean)
    zeilen.forEach(z => belegt.add(z.typ))
    return { titel: g.titel, zeilen }
  })
  const uebrig = rest.filter(z => !belegt.has(z.typ))
  if (uebrig.length) gruppen.push({ titel: 'Weitere', zeilen: uebrig })
  return gruppen.filter(g => g.zeilen.length)
})

function fuehrt(z, seite) {
  const h = zuZahl(z.heim), a = zuZahl(z.auswaerts)
  return seite === 'heim' ? h >= a : a >= h
}
const segFlex = w => Math.max(zuZahl(w), 0.01)
const xgText = w => (w == null ? '–' : zuZahl(w).toFixed(2))

const tabsRef = ref(null)

function aktivenTabZeigen(smooth = true) {
  tabsRef.value
    ?.querySelector('.tm-toggle__btn--active')
    ?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: smooth ? 'smooth' : 'auto' })
}

// beim Tabwechsel
watch(() => props.detail.tab, async () => { await nextTick(); aktivenTabZeigen() })
// beim ersten Anzeigen der Leiste (ohne Animation)
watch(tabsRef, async el => { if (el) { await nextTick(); aktivenTabZeigen(false) } })

function formVon(spiele, teamName) {
  return [...(spiele ?? [])]
    .filter(s => s.status === 'beendet' && s.heimtore != null)
    .sort((a, b) => new Date(b.zeit) - new Date(a.zeit))
    .slice(0, 5)
    .reverse()                                   // älteste links, neuestes rechts
    .map(s => {
      const heim = s.heim === teamName
      const f = heim ? s.heimtore : s.austore
      const g = heim ? s.austore : s.heimtore
      return f > g ? 'S' : f === g ? 'U' : 'N'
    })
}
const formHeim = computed(() => m.value.status === 'geplant' ? formVon(m.value.spieleHeim, m.value.heim) : [])
const formAuswaerts = computed(() => m.value.status === 'geplant' ? formVon(m.value.spieleAuswaerts, m.value.auswaerts) : [])

// Tabellenplatz eines Teams in der Liga dieses Spiels (null, wenn keine Tabelle da ist)
function platzVon(teamId) {
  if (teamId == null || m.value.ligaId == null) return null
  const gruppen = tabelleFuerLiga(props.tabellen, m.value.ligaId) ?? []
  const eintraege = gruppen.flatMap(g => g.standings ?? [g])
  const e = eintraege.find(x => Number(x.team?.id) === Number(teamId))
  return e?.rank ?? null
}
const platzHeim = computed(() => m.value.status === 'geplant' ? platzVon(m.value.heimId) : null)
const platzAuswaerts = computed(() => m.value.status === 'geplant' ? platzVon(m.value.auswaertsId) : null)

const statistikFarben = computed(() => {
  const roh = c => hexFarbe(c)
  const h = roh(heim.value?.team?.colors?.player?.primary)
  const a = roh(auswaerts.value?.team?.colors?.player?.primary)
  // brauchbar: nicht zu hell (weißer Text bleibt lesbar) und nicht zu dunkel
  const brauchbar = c => { const l = leuchtdichte(c); return l != null && l > 0.12 && l < 0.65 }
  const rgb = c => [1, 3, 5].map(i => parseInt(c.slice(i, i + 2), 16))
  const abstand = (x, y) => Math.hypot(...rgb(x).map((v, i) => v - rgb(y)[i]))

  const ch = brauchbar(h) ? h : '#1d9e75'
  let ca = brauchbar(a) ? a : '#e8833a'
  if (abstand(ch, ca) < 90) ca = ch === '#e8833a' ? '#1d9e75' : '#e8833a'   // zu ähnlich: Auswärts auf Fallback
  return { '--tm-heim': ch, '--tm-aus': ca }
})

watch(
  () => [verfuegbareTabs.value, props.detail.tab],
  ([tabs, aktuell]) => {
    if (!tabs?.length) return
    if (!tabs.includes(aktuell)) emit('change-tab', tabs[0])
  },
  { immediate: true }
)

</script>